<template>
        
    <div class="row">

        <BulkAction
            v-if="hasBulkAction"
            :bulkLoading="bulkLoading"
            :hasMultiSelect="hasMultiSelect"
            :exportLoading="exportLoading"
            :permissions="permissions"
            :refs="refs"

            :search="search"
            :date="date"
            :status="status"
                
            v-on:activeChange="handelActiveChange"
            v-on:inactiveChange="handelInActiveChange"
            v-on:refreshTable="fetchData"
                
            :fields="fields"
            :selected="selected">
        </BulkAction>
        

        <div class="col-12">
            <div class="card">
                <div class="card-body">

                    <div class="row mb-2">
                        <div class="col-sm-11"
                            :style="($i18n.locale == 'ar') ? '' : 'text-align: left'">
                            <h5 :class="($i18n.locale == 'ar') ? 'hacen_algeria' : 'mrl-5'">
                                {{ $t('app.all_rows') }} 
                                <span v-if="dataLoading">
                                    <span 
                                        class="spinner-grow spinner-grow-sm mr-1" 
                                        role="status" 
                                        aria-hidden="true">
                                    </span>
                                </span>
                                <span v-if="!dataLoading">( {{ total }} )</span>
                            </h5>
                            <div class="search-box me-2 mb-2 d-inline-block">
                                <div class="position-relative">
                                    <form @submit.prevent="fetchData">
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria' : ''"
                                            :placeholder="$t('app.search')"
                                            v-model="search">
                                        <i class="bx bx-search-alt search-icon"></i>
                                    </form>
                                </div>
                            </div>

                            <div v-if="hasRoleFilter && !roleLoading" 
                                class="search-box d-inline-block"
                                :class="($i18n.locale == 'ar') ? 'ml-2' : 'mr-2'">
                                <div class="position-relative">
                                    <select 
                                        class="form-control"
                                        v-model="role_id"
                                        @change="fetchData"
                                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''">
                                        <option value="">{{ $t('view.role_name') }}</option>
                                        <option 
                                            v-for="(role, idx) in roles"
                                            :key="idx"
                                            :value="role.id">
                                            {{ role.title }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="hasFilterByCategory && !categoryLoading" 
                                class="search-box d-inline-block"
                                :class="($i18n.locale == 'ar') ? 'ml-2' : 'mr-2'">
                                <div class="position-relative">
                                    <select 
                                        class="form-control"
                                        v-model="employee_category_id"
                                        @change="fetchData"
                                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                        :style="($i18n.locale == 'ar') ? '' : 'padding-left:15px;padding-right:40px'">
                                        <option value="">{{ $t('view.employee_category') }}</option>
                                        <option 
                                            v-for="(cat, idx) in categories"
                                            :key="idx"
                                            :value="cat.id">
                                            {{ cat[$i18n.locale]['title'] }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="hasFilterByJobTitles && !jobTitleLoading" 
                                class="search-box d-inline-block"
                                :class="($i18n.locale == 'ar') ? 'ml-2' : 'mr-2'">
                                <div class="position-relative">
                                    <select 
                                        class="form-control"
                                        v-model="job_title_id"
                                        @change="fetchData"
                                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                        :style="($i18n.locale == 'ar') ? '' : 'padding-left:15px;padding-right:40px'">
                                        <option value="">{{ $t('view.employee_jobTitle') }}</option>
                                        <option 
                                            v-for="(job, idx) in jobTitles"
                                            :key="idx"
                                            :value="job.id">
                                            {{ job[$i18n.locale]['title'] }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="hasFilterByNationality && !nationalityLoading" 
                                class="search-box d-inline-block"
                                :class="($i18n.locale == 'ar') ? 'ml-3' : 'mr-3'">
                                <div class="position-relative">
                                    <select 
                                        class="form-control"
                                        v-model="nationality_id"
                                        @change="fetchData"
                                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                        :style="($i18n.locale == 'ar') ? '' : 'padding-left:15px;padding-right:40px'">
                                        <option value="">{{ $t('view.employee_nationality') }}</option>
                                        <option 
                                            v-for="(nationality, idx) in nationalities"
                                            :key="idx"
                                            :value="nationality.id">
                                            {{ nationality[$i18n.locale]['title'] }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="search-box d-inline-block"
                                 v-if="hasFilterByDate"
                                :class="($i18n.locale == 'ar') ? 'ml-3' : 'mr-3'">
                                <div class="position-relative">
                                    <input 
                                        type="date" 
                                        class="form-control"
                                        v-model="date"
                                        @change="fetchData"
                                        style="width: 150px;padding:10px">
                                    <span 
                                        class="search-icon">
                                        <i v-if="date" @click="clearDate" class="fa fa-times cursor-pointer font-size-13"></i>
                                    </span>
                                </div>
                            </div>

                            <div v-if="hasFilterByEndDate" 
                                class="search-box d-inline-block"
                                :class="($i18n.locale == 'ar') ? 'ml-3' : 'mr-3'">
                                <div class="position-relative">
                                    <input 
                                        type="date" 
                                        class="form-control"
                                        v-model="end_date"
                                        @change="fetchData"
                                        style="width: 150px;padding:10px">
                                    <span 
                                        class="search-icon">
                                        <i v-if="end_date" @click="clearEndDate" class="fa fa-times cursor-pointer font-size-13"></i>
                                    </span>
                                </div>
                            </div>


                            <div v-if="hasFilterByStartDate"
                                class="search-box d-inline-block"
                                :class="($i18n.locale == 'ar') ? 'ml-3' : 'mr-3'">
                                <div class="position-relative">
                                    <input
                                        type="date"
                                        class="form-control"
                                        v-model="start_date"
                                        @change="fetchData"
                                        style="width: 150px;padding:10px">
                                    <span
                                        class="search-icon">
                                        <i v-if="start_date" @click="clearEndDate" class="fa fa-times cursor-pointer font-size-13"></i>
                                    </span>
                                </div>
                            </div>


                            <div class="search-box d-inline-block"
                                :class="($i18n.locale == 'ar') ? 'ml-3' : 'mr-3'">
                                <div class="position-relative">
                                    <select 
                                        class="form-control"
                                        v-model="status"
                                        @change="fetchData"
                                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'pd-10'">
                                        <option value="">{{ $t('app.status') }}</option>
                                        <option value="active"
                                            v-html="(hasSeen) ? $t('app.seen') : $t('app.active')">
                                        </option>
                                        <option value="inactive"
                                            v-html="(hasSeen) ? $t('app.unseen') : $t('app.inactive')">
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-1">
                            <ShowEntries
                                :perPage="this.perPage"
                                v-on:showChange="handelShowChange">
                            </ShowEntries>
                        </div>

                    </div>
                
                    <div class="table-responsive">
                        <table id="printMe" class="table align-middle table-nowrap table-check">

                            <thead class="table-dark">
                                <tr>
                                    <th 
                                        v-if="hasMultiSelect"
                                        style="width: 5%" class="align-middle">
                                        <div class="form-check font-size-16">
                                            <input 
                                                class="form-check-input" 
                                                type="checkbox" 
                                                id="checkAll"
                                                v-model="selectAll" 
                                                @click="select">
                                            <label class="form-check-label" for="checkAll"></label>
                                        </div>
                                    </th>

                                    <th 
                                        v-if="hasHashId"
                                        style="width: 5%" class="text-center">
                                        #
                                    </th>

                                    <th 
                                        v-if="hasImage"
                                        style="width: 5%"
                                        class="align-middle font-weight-500 text-center"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16' 
                                                : 'font-size-14'">
                                        {{ image }}
                                    </th>

                                    <th 
                                        v-if="hasTitle"
                                        style="width: 15%"
                                        class="align-middle font-weight-500"
                                        :class="[($i18n.locale == 'ar') 
                                                    ? 'hacen_algeria font-size-16' 
                                                    : 'font-size-14 text-center', 
                                                (hasImage) 
                                                    ? 'text-center' 
                                                    : '']">
                                        {{ title }}
                                    </th>

                                    <th 
                                        v-if="hasName"
                                        style="width: 15%"
                                        class="align-middle font-weight-500"
                                        :class="[($i18n.locale == 'ar') 
                                                    ? 'hacen_algeria font-size-16' 
                                                    : 'font-size-14 text-center', 
                                                (hasImage) 
                                                    ? 'text-center' 
                                                    : '']">
                                        {{ name }}
                                    </th>

                                    <th 
                                        v-if="hasStar"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                            ? 'hacen_algeria font-size-16 ' 
                                            : 'font-size-14'">
                                        {{ star }}
                                    </th>

                                    <th 
                                        v-if="hasAmountDo"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                            ? 'hacen_algeria font-size-16 ' 
                                            : 'font-size-14'">
                                        {{ amountDuo }}
                                    </th>

                                    <th 
                                        v-if="hasEmail"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria  font-size-16' 
                                                : 'font-size-14'">
                                        {{ email }}
                                    </th>

                                    <th 
                                        v-if="hasCountNo"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                            ? 'hacen_algeria font-size-16 ' 
                                            : 'font-size-14'">
                                        {{ count_no }}
                                    </th>

                                    <th 
                                        v-if="hasColumn2"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16 ' 
                                                : 'font-size-14'">
                                        {{ column2 }}
                                    </th>

                                    <th 
                                        v-if="hasColumn3"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16 ' 
                                                : 'font-size-14'">
                                        {{ column3 }}
                                    </th>

                                    <th 
                                        v-if="hasTotal"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16 ' 
                                                : 'font-size-14'">
                                        {{ totalPrice }}
                                    </th>

                                    <th 
                                        v-if="hasRelation"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16 ' 
                                                : 'font-size-14'">
                                        {{ relation }}
                                    </th>

                                    <th 
                                        v-if="hasStartDate"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16 ' 
                                                : 'font-size-14'">
                                        {{ $t('app.start_date') }} 
                                    </th>

                                    <th
                                        v-if="hasContractEndDate"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar')
                                                ? 'hacen_algeria font-size-16 '
                                                : 'font-size-14'">
                                        {{ $t('app.contract_start_date') }}
                                    </th>

                                    <th 
                                        v-if="hasEndDate"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16 ' 
                                                : 'font-size-14'">
                                        {{ $t('app.end_date') }} 
                                    </th>

                                    <th
                                        v-if="hasContractEndDate"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar')
                                                ? 'hacen_algeria font-size-16 '
                                                : 'font-size-14'">
                                        {{ $t('app.contract_end_date') }}
                                    </th>

                                    <th 
                                        v-if="hasDate"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16 ' 
                                                : 'font-size-14'">
                                        {{ $t('app.date') }} 
                                    </th>

                                    <th 
                                        v-if="hasStatus || hasStatus2"
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16 ' 
                                                : 'font-size-14'">
                                        {{ $t('app.status') }}
                                    </th>

                                    <th 
                                        v-if="hasActions" 
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16' 
                                                : 'font-size-14'">
                                        {{ $t('app.actions') }}
                                    </th>
                                </tr>
                            </thead>
                            
                            <tbody v-if="dataLoading">
                                <tr>
                                    <td 
                                        :colspan="colspan" 
                                        class="text-center">
                                        <span 
                                            class="spinner-grow spinner-grow-sm mr-1" 
                                            role="status" 
                                            aria-hidden="true">
                                        </span>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody v-if="!dataLoading && !items.length">
                                <tr>
                                    <td 
                                        :colspan="colspan" 
                                        class="text-center"
                                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''">
                                        <span>{{ $t('app.no_data') }}</span>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody v-if="!dataLoading && items.length">
                                <tr 
                                    v-for="(item, idx) in items" 
                                    :key="idx" 
                                    :class="(item.alert) ? 'alert-danger' : ''">

                                    <td v-if="hasMultiSelect">
                                        <div class="form-check font-size-16">
                                            <input 
                                                :id="'expBox'+item.id" 
                                                class="form-check-input" 
                                                type="checkbox" 
                                                v-model="selected" 
                                                :value="item.id">
                                            <label 
                                                class="form-check-label" 
                                                :for="'expBox'+item.id">
                                            </label>
                                        </div>
                                    </td>

                                    <td v-if="hasHashId" class="text-center">
                                        {{ idx+1 }}
                                    </td>

                                    <td v-if="hasInvoiceId" class="text-center">
                                        <router-link 
                                            class="default-color"
                                            :to="{ name: 'edit-'+refs, params:{id: item.encrypt_id}}">
                                            {{ item.invoice_id }}
                                        </router-link>
                                    </td>

                                    <td 
                                        class="text-center" 
                                        v-if="hasImage">

                                        <router-link 
                                            v-if="permissions.edit"
                                            :to="(redirectToEmployee) 
                                                ? {name: 'edit-employees', params:{id: item.image.encrypt_id}}
                                                : {name: 'edit-'+refs, params:{id: item.encrypt_id}}">
                                            <img 
                                                :src="(item.image) ? item.image.url : ''" 
                                                :style="image_style">
                                            <span 
                                                class="default-color"
                                                v-if="item.image.name" 
                                                :class="($i18n.locale == 'ar') 
                                                    ? 'hacen_algeria font-size-14' : ''"> 
                                                    {{ item.image.name }}
                                            </span>
                                        </router-link>
                                        
                                            <img 
                                                v-if="!permissions.edit"
                                                :src="(item.image) ? item.image.url : ''" 
                                                :style="image_style">
                                            <span 
                                                class="default-color"
                                                v-if="!permissions.edit && item.image.name" 
                                                :class="($i18n.locale == 'ar') 
                                                    ? 'hacen_algeria font-size-14' : ''"> 
                                                    {{ item.image.name }}
                                            </span>
                                    </td>

                                    <td 
                                        v-if="hasTitle"
                                        :class="[($i18n.locale == 'ar') 
                                                    ? 'hacen_algeria font-size-14' 
                                                    : 'text-center', 
                                                (hasImage) 
                                                    ? 'text-center' 
                                                    : '']">
                                        <router-link 
                                            v-if="permissions.edit"
                                            :to="{ name: 'edit-'+refs, params:{id: item.encrypt_id}, query:{parent_id: parent_id, slug: slug}}"
                                            class="default-color">
                                            {{ ($i18n.locale == 'ar') ? item.ar.title : item.en.title }}
                                        </router-link>

                                        <span v-if="!permissions.edit">
                                            {{ ($i18n.locale == 'ar') ? item.ar.title : item.en.title }}
                                        </span>
                                    </td>

                                    <td 
                                        v-if="hasName"
                                        :class="[($i18n.locale == 'ar') 
                                                    ? 'hacen_algeria font-size-14' 
                                                    : 'text-center', 
                                                (hasImage) 
                                                    ? 'text-center' 
                                                    : '']">
                                        <router-link 
                                            v-if="permissions.edit"
                                            :to="{ name: 'edit-'+refs, params:{id: item.encrypt_id}, query:{parent_id: parent_id, slug: slug}}"
                                            class="default-color">
                                            {{ item.name }}
                                        </router-link>

                                        <span v-if="!permissions.edit">
                                            {{ item.name }}
                                        </span>
                                    </td>

                                    <td 
                                        v-if="hasAmountDo"
                                        class="text-center"
                                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''">
                                        {{ item.amount_duo }}
                                    </td>

                                    <td 
                                        v-if="hasEmail"
                                        class="text-center"
                                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''">
                                        {{ item.email }}
                                    </td>

                                    <td 
                                        v-if="hasCountNo" 
                                        class="text-center">
                                        <label
                                            class="badge rounded-pill badge-md badge-soft-primary"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px">
                                            {{ item.count_no }}
                                        </label>
                                    </td>

                                    <td 
                                        v-if="hasColumn2" 
                                        class="text-center">
                                        <label
                                            class="badge rounded-pill badge-md badge-soft-primary"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px">
                                            {{ item.column2 }}
                                            <div v-if="item.column2_sub"
                                                style="direction: ltr; margin-top:-10px">
                                                <br/>{{ item.column2_sub }}
                                            </div>
                                        </label>
                                    </td>

                                    <td 
                                        v-if="hasColumn3" 
                                        class="text-center">
                                        <label
                                            class="badge rounded-pill badge-md badge-soft-primary"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px">
                                            {{ item.column3 }}
                                        </label>
                                    </td>

                                    <td 
                                        v-if="hasTotal" 
                                        class="text-center">
                                        <label
                                            class="badge rounded-pill badge-md badge-soft-primary"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px">
                                            {{ item.total }}
                                        </label>
                                    </td>

                                    <td 
                                        v-if="hasRelation" 
                                        class="text-center">
                                        <label
                                            class="badge rounded-pill badge-md badge-soft-primary"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px">
                                            {{ (item.relation_name) ? item.relation_name.ar.title : '' }}
                                        </label>
                                    </td>

                                    <td 
                                        v-if="isAdmin"
                                        class="text-center">
                                        <label
                                            class="badge rounded-pill badge-md badge-soft-danger"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px">
                                            {{ (item.user) ?(item.user.partner) ? item.user.partner.title : '' : '' }}
                                        </label>
                                    </td>
                                    <td 
                                        v-if="isAdmin2"
                                        class="text-center">
                                        <label
                                            class="badge rounded-pill badge-md badge-soft-danger"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px">
                                            {{ (item.partner) ? item.partner.title : '' }}
                                        </label>
                                    </td>

                                    <td 
                                        v-if="hasStartDate || hasContractEndDate"
                                        class="text-center">
                                        {{ item.start_date }}
                                    </td>

                                    <td 
                                        v-if="hasEndDate || hasContractEndDate"
                                        class="text-center">
                                        {{ item.end_date }}
                                    </td>

                                    <td 
                                        v-if="hasDate"
                                        class="text-center">
                                        {{ item.date }}
                                    </td>

                                    <td 
                                        v-if="hasStatus"
                                        class="text-center">
                                        <label v-if="item.status"
                                            class="badge rounded-pill badge-md badge-soft-success"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px"
                                            v-html="(hasSeen) ? $t('app.seen') : $t('app.active')">
                                        </label>
                                        <label v-else
                                            class="badge rounded-pill badge-md badge-soft-danger"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px"
                                            v-html="(hasSeen) ? $t('app.unseen') : $t('app.inactive')">
                                        </label>
                                    </td>

                                    <td 
                                        v-if="hasStatus2"
                                        class="text-center">

                                        <label v-if="item.cancelled"
                                            class="badge rounded-pill badge-md badge-soft-danger"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px">
                                            {{ $t('app.cancelled') }}
                                        </label>

                                        <label v-if="!item.cancelled && item.approved"
                                            class="badge rounded-pill badge-md badge-soft-success"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px">
                                            {{ $t('app.approved') }}
                                        </label>

                                        <label v-if="!item.approved && !item.cancelled"
                                            class="badge rounded-pill badge-md badge-soft-dark"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px">
                                            -
                                        </label>

                                    </td>

                                    <td 
                                        v-if="hasActions"
                                        class="align-middle">
                                        <div class="col-12 text-center">
                                            <button 
                                                v-if="permissions.edit"
                                                type="button"
                                                @click="editItem(item.encrypt_id)"
                                                class="btn btn-success btn-rounded btn-sm ml-1"
                                                style="width: 32px;height:32px;padding:0;margin-left:5px"
                                                title="Edit">
                                                <i class="mdi mdi-pencil font-size-16"></i>
                                            </button>
                                            <button 
                                                v-if="hasReport && permissions.edit"
                                                type="button"
                                                @click="analyticsItem(item.encrypt_id)"
                                                class="btn btn-primary btn-rounded btn-sm ml-1"
                                                style="width: 32px;height:32px;padding:0;margin-left:5px"
                                                title="Analytics">
                                                <i class="bx bx-line-chart font-size-16" style="padding: 6px"></i>
                                            </button>
                                            <button 
                                                type="button"
                                                v-if="hasExportPDF && !item.loading && permissions.edit"
                                                @click="item.loading=true; exportPDFItem(item.encrypt_id);"
                                                class="btn btn-primary btn-rounded btn-sm ml-1"
                                                style="width: 32px;height:32px;padding:0;margin-left:5px"
                                                title="Export PDF">
                                                <i class="bx bx-file font-size-16" style="padding: 6px"></i>
                                            </button>
                                            <button 
                                                type="button"
                                                v-if="!item.loading && permissions.delete"
                                                @click="item.loading=true; deleteItem(item.encrypt_id);"
                                                class="btn btn-danger btn-rounded btn-sm ml-1"
                                                style="width: 32px;height:32px;padding:0"
                                                title="Delete">
                                                <i class="mdi mdi-delete font-size-16"></i>
                                            </button>
                                            <span v-if="!permissions.edit && !permissions.delete">
                                                <span 
                                                    class="badge rounded-pill badge-md badge-soft-danger"
                                                    style="padding: 10px">
                                                    {{ $t('view.noPermissionGranted') }}
                                                </span>
                                            </span>
                                            <span v-if="item.loading">
                                                <span 
                                                    class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </span>
                                        </div>
                                    </td>

                                </tr>

                            </tbody>
                        </table>
                    </div>



                    <p></p>
                    <Pagination 
                        v-if="!dataLoading"
                        :items="items"
                        :pageCount="pageCount"
                        v-on:pageChange="handelPageChange">
                    </Pagination>
                    

                </div>
            </div>
        </div>

    </div>
        
</template>

<script>
import iziToast from 'izitoast';

export default {
    namme: 'Table',
    props: [
        'refs',
        'colspan',
        'watchCountryId',

        'hasMultiSelect',
        'hasBulkAction',
        'hasExport',
        'hasExportPDF',
        'hasShowEntries',
        'hasSearch',
        'hasRoleFilter',
        'hasMenuFilter',
        'hasPartnerFilter',

        'roleWhereNotIn',

        'hasInvoiceId',
        'hasHashId',

        'isAdmin',
        'isAdmin2',

        'hasImage',
        'redirectToEmployee',
        'image',
        'image_style',

        'hasName',
        'name',

        'hasTitle',
        'title',

        'hasStar',
        'star',

        'hasEmail',
        'email',

        'hasAmountDo',
        'amountDuo',

        'hasCountNo',
        'count_no',

        'hasColumn2',
        'column2',

        'hasColumn3',
        'column3',
        
        'hasColumn4',
        'column4',

        'hasTotal',
        'totalPrice',

        'hasRelation',
        'relation',

        'hasAuthor',

        'hasStartDate',
        'hasEndDate',

        'hasContractEndDate',
        'hasContractStartDate',

        'hasFilterByCategory',
        'hasFilterByJobTitles',
        'hasFilterByNationality',
        'hasFilterByHiringDate',
        'hasFilterByDate',
        'hasFilterByEndDate',
        'hasFilterByStartDate',

        'hasDate',
        'hasStatus',
        'hasStatus2',
        'hasActions',
        'hasSeen',

        'hasReport',

        'actionable',
        'sortable'
    ],
    components: {
        BulkAction: () => import('@/components/BulkAction.vue'),
        ShowEntries: () => import('@/components/ShowEntries.vue'),
        Pagination: () => import('@/components/Pagination.vue'),
    },
    data(){
        return {
            auth: {
                role: '',
                access_token: ''
            },

            fields: this.$props.fields,

            selected: [],
            selectAll: false,

            parent_id: '',
            slug: '',

            permissions: {
                add: false,
                edit: false,
                delete: false
            },

            search: '',
            status: '',
            date: '',
            end_date: '',
            start_date: '',
            filter_by: '',
            filter: '',
            order: '',
            order_by: '',

            employee_category_id: '',
            categories: [],
            categoryLoading: true,

            job_title_id: '',
            jobTitles: [],
            jobTitleLoading: true,

            nationality_id: '',
            nationalities: [],
            nationalityLoading: true,

            dataLoading: true,
            bulkLoading: true,
            exportLoading: true,
            orderLoading: false,
            authorLoading: false,

            roleLoading: true,
            role_id: '',
            roles: [],

            items: [],
            total: 0,
            page: 1, 
            perPage: 10,
            pageCount: 10,
            country_id: this.$props.watchCountryId,
        }
    },
    watch: {
        watchCountryId: function(new_val) {
            this.country_id = new_val;
            this.fetchData(true);
        }
    },
    mounted() {},
    created() {
      
        // accessToken
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }
        if(localStorage.getItem('role')) {
            this.auth.role = localStorage.getItem('role');
        }
        if(this.$route.query.parent_id) {
            this.parent_id = this.$route.query.parent_id;
        }
        if(this.$route.query.slug) {
            this.slug = this.$route.query.slug;
        }

        // fetchData
        this.fetchData();

        if(this.$props.hasRoleFilter) {
            this.fetchRoles();
        }

        if(this.$props.hasFilterByCategory) {
            this.fetchEmployeeCategories();
        }
        if(this.$props.hasFilterByJobTitles) {
            this.fetchJobTitles();
        }

        if(this.$props.hasFilterByNationality) {
            this.fetchNationalties();
        }

    },
    methods: {

        fetchData(loading=false) {
            if(loading) { this.dataLoading = true; }
            this.plural = '',
            this.selectAll = false;
            this.selected = [];

            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };

            const options = {
                url: window.baseURL+'/'+this.$props.refs,
                method: 'GET',
                data: {},
                params: {
                    page: this.page,
                    paginate: this.perPage,
                    parent_id: this.parent_id,
                    country_id: this.country_id,
                    employee_category_id: this.employee_category_id,
                    nationality_id: this.nationality_id,
                    status: this.status,
                    date: this.date,
                    end_date: this.end_date,
                    start_date: this.start_date,
                    filter_by: this.filter_by,
                    filter: this.filter,
                    search: this.search,
                    order: this.order,
                    order_by: this.order_by,
                    role_id: this.role_id,
                    role: this.auth.role
                },
            }
            this.axios(options)
                .then(res => {
                    this.dataLoading = false;
                    this.bulkLoading = false;
                    this.exportLoading = false;
                    this.orderLoading = false;
                    this.categoryLoading = false;
                    this.authorLoading = false;

                    this.items = res.data.data.rows;
                    this.total = res.data.data.paginate.total;

                    this.permissions.add = res.data.data.permissions.add;
                    this.$emit('hasAddNewPermission', this.permissions.add);

                    this.permissions.edit = res.data.data.permissions.edit;
                    this.permissions.delete = res.data.data.permissions.delete;
                    
                    if(res.data.data.paginate.total) {
                        this.pageCount = Math.ceil(res.data.data.paginate.total / this.perPage);
                    }

                })
                .catch(err => {
                    //403 Forbidden
                    if(err.response && err.response.status == 401) {
                        this.clearLocalStorage();
                        this.$router.push({ name: 'login' });
                    } else if(err.response && err.response.status == 403) {
                        this.$router.push({ name: 'forbidden' });
                    } else {
                        this.btnLoading = false;
                        iziToast.warning({
                            icon: 'ti-alert',
                            title: '',
                            message: (err.response) ? err.response.data.message : ''+err
                        });
                    }
                })
                .finally(() => {})
        },


        fetchRoles() {
            this.roleLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/roles',
                method: 'GET',
                data: {},
                params: {
                    status: 'active',
                    whereNotIn: this.$props.roleWhereNotIn,
                    paginate: 100
                }
            }
            this.axios(options)
            .then(res => {
                this.roleLoading = false;
                this.roles = res.data.data.rows;
            })
            .catch(err => {
                this.roleLoading = false;
                iziToast.warning({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });
            })
        },


        fetchEmployeeCategories() {
            this.categoryLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/settings/employeecategories',
                method: 'GET',
                data: {},
                params: {
                    paginate: 100
                }
            }
            this.axios(options)
            .then(res => {
                this.categoryLoading = false;
                this.categories = res.data.row.childs;
            })
            .catch(err => {
                this.categoryLoading = false;
                iziToast.warning({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });
            })
        },

        fetchJobTitles() {
            this.jobTitleLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/settings/jobtitles',
                method: 'GET',
                data: {},
                params: {
                    paginate: 100
                }
            }
            this.axios(options)
            .then(res => {
                this.jobTitleLoading = false;
                this.jobTitles = res.data.row.childs;
            })
            .catch(err => {
                this.jobTitleLoading = false;
                iziToast.warning({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });
            })
        },


        fetchNationalties() {
            this.nationalityLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/settings/nationalities',
                method: 'GET',
                data: {},
                params: {
                    paginate: 100
                }
            }
            this.axios(options)
            .then(res => {
                this.nationalityLoading = false;
                this.nationalities = res.data.row.childs;
            })
            .catch(err => {
                this.nationalityLoading = false;
                iziToast.warning({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });
            })
        },


        // clear Local Storages
        clearLocalStorage() {
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_image');
            localStorage.removeItem('user_name');
            localStorage.removeItem('user_id');
            localStorage.removeItem('role');
        },

        clearDate() {
            this.date = '';
            this.fetchData();
        },
        clearEndDate() {
            this.end_date = '';
            this.fetchData();
        },

        // Handle Change from child components
        handelPageChange(event) {
            this.page = event;
            this.fetchData();
        },

        handelShowChange(event) {
            this.perPage = event;
            this.fetchData(true);
        },


        editItem(id) {
            if(this.$route.query.parent_id) {
                this.$router.push({ 
                    name: 'edit-'+this.$props.refs, 
                    params:{id: id}, 
                    query:{parent_id: this.parent_id, slug: this.slug} })
            } else {
                this.$router.push({ name: 'edit-'+this.$props.refs, params:{id: id} })
            }
        },

        analyticsItem(id) {
            if(this.$route.query.parent_id) {
                this.$router.push({ 
                    name: 'analytics-'+this.$props.refs, 
                    params:{id: id}, 
                    query:{parent_id: this.parent_id, slug: this.slug} })
            } else {
                this.$router.push({ name: 'analytics-'+this.$props.refs, params:{id: id} })
            }
        },

        deleteItem(id) {
            if(confirm('Are you sure?')) {
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer `+this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.$props.refs+'/'+id,
                    method: 'DELETE',
                    data: {},
                }
                this.axios(options)
                .then(() => {
                    this.fetchData(true); 
                    iziToast.success({
                        icon: 'bx bx-wink-smile',
                        title: '',
                        message: 'تم الحذف بنجاح',
                    }); 
                })
                .catch(err => {
                    this.fetchData(true); 
                    iziToast.error({
                        icon: 'bx bx-angry',
                        title: '',
                        message: (err.response) ? err.response.data.message : ''+err
                    });
                })
                .finally(() => {});
            } else { 
                // in case pressed cancel
                this.fetchData(true); 
            }
        },

        exportPDFItem(id){
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/'+this.$props.refs+'/export/pdf/'+id,
                method: 'GET',
                data: {},
            }
            this.axios(options)
            .then(res => {
                window.open(res.data.file, '_blank');
                this.fetchData(true); 
            })
            .catch(() => {})
            .finally(() => {});
        },



        select() {
            this.selected = [];
            if (!this.selectAll) {
                for (let i in this.items) {
                  this.selected.push(this.items[i].id);
                }
            }
        },

        
        activate(id){
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer `+this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/'+this.refs+'/active/'+id,
                method: 'POST',
                data: {},
            }
            this.axios(options)
            .then(() => {
                this.fetchData();
                iziToast.success({
                    icon: 'bx bx-wink-smile',
                    title: '',
                    message: 'تم التنشيط بنجاح'
                });
            })
            .catch(err => {
                this.fetchData();
                iziToast.error({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });

            })
            .finally(() => {});
        },


        inactivate(id){
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer `+this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/'+this.refs+'/inactive/'+id,
                method: 'POST',
                data: {},
            }
            this.axios(options)
            .then(() => {
                this.fetchData();
                iziToast.success({
                    icon: 'bx bx-wink-smile',
                    title: '',
                    message: 'تم إلغاء التنشيط بنجاح'
                });
            })
            .catch(err => {
                this.fetchData();
                iziToast.error({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });

            })
            .finally(() => {});
        },


        handelActiveChange() {
            if(this.selected.length == 0) {
                alert('من فضلك أختر العناصر اولاُ');
            } else {
                this.bulkLoading = true;
                this.activate(this.selected.join());
            }
        },

        handelInActiveChange() {
            if(this.selected.length == 0) {
                alert('من فضلك أختر العناصر اولاُ');
            } else {
                this.bulkLoading = true;
                this.inactivate(this.selected.join());
            }
        },


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
select, option { font-family: 'hacen_algeria' !important}
/* input[type="date"]::-webkit-datetime-edit, input[type="date"]::-webkit-inner-spin-button, input[type="date"]::-webkit-clear-button {
  color: #fff;
  position: relative;
}

input[type="date"]::-webkit-datetime-edit-year-field{
  position: absolute !important;
  /* border-left:1px solid #8c8c8c; */
  /* padding: 2px;
  color:#000;
  left: 56px;
}

input[type="date"]::-webkit-datetime-edit-month-field{
  position: absolute !important;
  /* border-left:1px solid #8c8c8c; */
  /* padding: 2px;
  color:#000;
  left: 26px;
}


input[type="date"]::-webkit-datetime-edit-day-field{
  position: absolute !important;
  color:#000;
  padding: 2px;
  left: 4px;
} */
</style>